import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, IcoClose } from '../../../component';
import { IconInformation } from '../../../component/icon/information';
import { heatmapLegend, zoningColors } from '../../../shared/constants';
import useOutsideClick from '../../../hooks/useOusideClick';
import Legend from './legend';
import './mapControls.scss';
import { RootState } from '../../../reducer';
import { buildHeatmapLegend } from '../heatmap/Factory/heatmap.factory';
import HeatmapLegend from './heatmapLegend/heatmapLegend';

const LayersLegends = (): JSX.Element => {
  const { preference } = useSelector((state: RootState) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);
  const containerRef = useRef(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { dataLayers } = useSelector(
    (state: RootState) => state.dataLayersState
  );
  const { isActive: isHeatmapActive } = useSelector(
    (state: RootState) => state.heatmap
  );

  useOutsideClick(containerRef, setIsOpen);

  const hasAverageIncome = dataLayers.averageIncome.options.some(
    ({ checked }) => checked
  );

  const isDisabled = (): boolean => {
    return (
      !dataLayers.zoning.selected &&
      !dataLayers.neighborhood.selected &&
      !dataLayers.valueZoning.selected &&
      !hasAverageIncome &&
      !isHeatmapActive
    );
  };

  useEffect(() => {
    if (isDisabled()) setIsOpen(false);
  }, [isDisabled]);

  return (
    <div className="layers-legends-external-container" ref={containerRef}>
      {isOpen && (
        <div className="layers-legends-internal-container">
          <div className="layers-legends-title-container">
            <p>{nls.layersLegends.title}</p>
            <Button
              cy="MapViewCloseBtn"
              className="btn normal"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <IcoClose cy="IconCloseMapView" />
            </Button>
          </div>
          <div className="layers-legends-body-container">
            {dataLayers.neighborhood.selected && (
              <>
                <h2>{nls.layersLegends.neighborhood}</h2>
                <div className="layers-legends-neighborhood-container">
                  <Legend
                    text={''}
                    bgColor={'rgb(56 57 57 / 40%)'}
                    displayIcon={false}
                    border
                  />
                </div>
              </>
            )}
            {dataLayers.valueZoning.selected && (
              <>
                <h2>{nls.layersLegends.valueZoning}</h2>
                <div className="layers-legends-value-zoning-container">
                  <Legend
                    text={''}
                    bgColor={'#E5E5E5'}
                    displayIcon={false}
                    border
                  />
                </div>
              </>
            )}
            {dataLayers.zoning.selected && (
              <>
                <h2>{nls.layersLegends.zoning}</h2>
                <div className="layers-legends-zoning-container">
                  {Object.keys(zoningColors).map((zone, index) => {
                    return (
                      <Legend
                        text={zone}
                        bgColor={
                          zoningColors[zone as keyof typeof zoningColors]
                        }
                        key={`legend-${index}-${zone}`}
                      />
                    );
                  })}
                </div>
              </>
            )}
            {hasAverageIncome && (
              <>
                <h2>{nls.layersLegends.averageIncome}</h2>
                <div className="layers-legends-average-income-container">
                  {dataLayers.averageIncome.options.map((income) => (
                    <Legend
                      key={crypto.randomUUID()}
                      text={income.label.replace(/por domicílio/g, '')}
                      bgColor={income.color}
                      displayIcon={false}
                    />
                  ))}
                </div>
              </>
            )}
            {isHeatmapActive && <HeatmapLegend />}
          </div>
        </div>
      )}
      <Button
        cy="LayersLegends"
        className={`btn ${isOpen ? 'active' : ''}`}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        disabled={isDisabled()}
      >
        <IconInformation
          cy="LayersLegends"
          fill={isOpen ? '#FFFFFF' : '#793EAD'}
        />
      </Button>
    </div>
  );
};

export default LayersLegends;
